import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/sass/app.scss';
import 'bootstrap';
import ServiceCard from './components/ServiceCard.vue';

const app = createApp(App);

app.use(router);

app.mount('#app');
app.component('ServiceCard', ServiceCard);